import { createAction, createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownOptions } from "../../../utilities/commonUtilities";
import { getBatchCaseCalculations } from "../../../services/calculations/calculation-input/ProjectTab.service";
import { ProjectStatus } from "../../../utilities/AppConstants";

interface State {
    loading: boolean;
    error?: string;
    projectAndAffiliations: any;
    projectsCache: any;
    projectReadOnly?: boolean;
    isNavigating?: boolean;
}

export const initialState: State = {
    loading: false,
    error: '',
    projectAndAffiliations: null,
    projectsCache: null,
    projectReadOnly: false,
    isNavigating: false
};

export const getProjectAndAffiliations = createAction<string>("projectHeader/getProjectAndAffiliations");
export const updateProjectAndAffiliationsRequest = createAction<any>("projectHeader/updateProjectAndAffiliationsRequest");

export const fetchBatchCaseCalculations = createAsyncThunk(
    "connexia-projectsAndAffiliations/fetchBatchCaseCalculations",
    async (ids: Array<string>) => {

        const response = await getBatchCaseCalculations(ids);
        return response;
    }
);

const projectHeaderSlice = createSlice({
    name: 'projectHeader',
    initialState,
    reducers: {
        resetProjectHeader: () => ({
            ...initialState
        }),
        resetProjectsCache: (state, action: PayloadAction<any>) => {
            state.projectsCache = null;
        },
        updateProjectAndAffiliations: (state, action: PayloadAction<any>) => {
            state.projectAndAffiliations = action.payload;
        },
        setNavigationLoading: (state, action: PayloadAction<boolean>) => {
            state.isNavigating = action.payload;
        },
        setProjectAndAffiliations: (state, action: PayloadAction<{ data: any; projectReadOnly: boolean }>) => {
            state.projectAndAffiliations = action.payload.data;
            state.projectReadOnly = action.payload.projectReadOnly;
            state.loading = false;
            state.error = "";
        },
        setProjectAndAffiliationsLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
            if (action.payload) {
                state.error = "";
            }
        },
        setProjectAndAffiliationsError: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchBatchCaseCalculations.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(fetchBatchCaseCalculations.fulfilled, (state, action) => {
            state.projectsCache = { ...state.projectsCache, ...(action.payload as any) };
            state.loading = false;
            state.error = "";
        });
        builder.addCase(fetchBatchCaseCalculations.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
export const { 
    resetProjectHeader, 
    updateProjectAndAffiliations, 
    setNavigationLoading,
    setProjectAndAffiliations,
    setProjectAndAffiliationsLoading,
    setProjectAndAffiliationsError
} = projectHeaderSlice?.actions;

export const { resetProjectsCache } = projectHeaderSlice?.actions;

export default projectHeaderSlice.reducer;